var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23998_87505)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23998_87505",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 16,
    height: 17
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_23998_87505)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_23998_87505",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 -0.000488281H0V15.9995H16V-0.000488281Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_23998_87505)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66699 6.99951C6.04771 6.99951 7.16699 5.88023 7.16699 4.49951C7.16699 3.1188 6.04771 1.99951 4.66699 1.99951C3.28628 1.99951 2.16699 3.1188 2.16699 4.49951C2.16699 5.88023 3.28628 6.99951 4.66699 6.99951ZM4.66699 5.66618C5.31133 5.66618 5.83366 5.14385 5.83366 4.49951C5.83366 3.85518 5.31133 3.33285 4.66699 3.33285C4.02266 3.33285 3.50033 3.85518 3.50033 4.49951C3.50033 5.14385 4.02266 5.66618 4.66699 5.66618Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.833 4.49951C13.833 5.88023 12.7137 6.99951 11.333 6.99951C9.95227 6.99951 8.83301 5.88023 8.83301 4.49951C8.83301 3.1188 9.95227 1.99951 11.333 1.99951C12.7137 1.99951 13.833 3.1188 13.833 4.49951ZM12.4997 4.49951C12.4997 5.14385 11.9773 5.66618 11.333 5.66618C10.6887 5.66618 10.1663 5.14385 10.1663 4.49951C10.1663 3.85518 10.6887 3.33285 11.333 3.33285C11.9773 3.33285 12.4997 3.85518 12.4997 4.49951Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33333 10.3322C8.96033 9.83578 8.50987 9.40078 8 9.04511C7.05513 8.38605 5.90604 7.99951 4.66667 7.99951C2.75847 7.99951 1.06427 8.91578 0 10.3322V13.3328H9.33333V10.3322ZM4.66667 9.33285C5.98742 9.33285 7.1752 9.90071 8 10.8096V11.9995H1.33333V10.8096C2.1581 9.90071 3.34591 9.33285 4.66667 9.33285Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3336 9.33285C12.6543 9.33285 13.8422 9.90071 14.6669 10.8096V11.9995H10.6669V13.3328H16.0002V10.3323C14.936 8.91578 13.2418 7.99951 11.3336 7.99951C10.6179 7.99951 9.93236 8.12838 9.29883 8.36418C9.68003 8.68731 10.0268 9.04938 10.333 9.44418C10.6545 9.37131 10.9893 9.33285 11.3336 9.33285Z",
    fill: "black"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23998_87505)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -0.000488281,
    width: 16,
    height: 16,
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23998_87505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 -0.000488281)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_23998_87505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 -0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.06df663bd24261ffe5b7f0bce7a8cb14.svg";
export { ForwardRef as ReactComponent };